/* eslint-disable @typescript-eslint/no-this-alias */
/* eslint-disable @typescript-eslint/no-unused-vars */
import * as Sentry from '@sentry/browser';
import $ from 'jquery';

import {
  getBuildVersion,
  getUlrTests,
  getUrlCSS,
  getUrlMedia,
  runLocalTest,
} from '../spdConfig';
import { DEBUG_MODE } from '../spdConfig';
import { SPD } from '../spd';

import { Loader } from './loader';
import { SPDKeyboard } from './spdKeyboard';
import * as Configuration from './testConfiguration';
import { TextSelector, DbTexts, Text, TextId } from './textSelector';
import { Speaker } from './speaker';
import { FooterTools, Tools } from './footerTools';
import { TimersManager } from './timersManager';
import { Answer, AnswerAction, CodeAnswer, ConditionNextTask } from './answer';
import { GivenAnswer, Results } from './results';
import { ModeSurvey, TestSignature } from './survey';
import { ActivePicture, TypeActionOnActivePicture } from './activePicture';
import { MySound, SoundParam } from './sound';
import { EngineInterface } from './engineInterface';
import { SupervisorMonitor } from './supervisorMonitor';
import { FullScreen } from './fullScreen';

declare let speaker: Speaker;
declare let spd: SPD;
// eslint-disable-next-line @typescript-eslint/no-explicit-any
declare let taskEngine: any;
// eslint-disable-next-line @typescript-eslint/no-explicit-any
declare let taskEnginesMap: Map<string, EngineInterface>;
declare let supervisorMonitor: SupervisorMonitor;
declare let testConfiguration: Configuration.TestConfiguration;

type DataTest = {
  id: string;
  title: string;
  theme: string | string[];
  default_task: Task;
  db_texts?: DbTexts;
  tasks: Task[];
};

export type TaskNumber = string;

export enum ModeTest {
  StopOnAnswer = 'stopOnAnswer',
  StopOnSpecificAnswer = 'stopOnSpecificAnswer',
  AlwaysStop = 'alwaysStop',
  StopOnFullMode = 'stopOnFullMode',
  Skip = 'skip',
  HiddenOnStandardMode = 'hiddenOnStandardMode',
  HiddenForExamined = 'hiddenForExamined',
}

enum KeyboardType {
  full = 'full',
  pin = 'pin',
}

export type Task = {
  number: TaskNumber;
  template?: string;
  engine?: string;
  title: TextId;
  tools: Tools;
  must_read?: boolean; /// wymuszenie przeczytania tekstu niezależnie czy speaker jest włączony
  background_img?: string;
  camera?: boolean;
  map_answers: string;
  over_background_img: string;
  hint_background_img?: string | null;
  time_min_task_presentation: number | null | undefined;
  time_max_task_execution: number | null | undefined;
  time_min_task_execution: number | null | undefined;
  time_task_execution: number | null | undefined;
  time_max_test_execution: number;
  timeout_task: TaskNumber | null | undefined;
  time_next_delay: number;
  task_text: TextId;
  task_textPL: string; //standardowa odpowiedź po Polsku do zapisu w wynikach
  task_lange: Configuration.Lange;
  specific_answers: boolean;
  db_texts?: DbTexts | undefined;
  answers: Answer[];
  hints: Hint[];
  snd_good_click: string;
  snd_bad_click: string;
  snd_click: string;
  snd_task: SoundParam;
  only_correct: boolean;
  mandatory_answer: boolean;
  next_after_answer: boolean;
  mode: ModeTest;
  mode_answer: CodeAnswer;
  keyboard: KeyboardType;
  body_class?: string;
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  template_parameters?: any;
  only_engine_hint?: boolean;
  speaker_volume?: number;
};

/// next_after_answer przechodzi do następnego zadania po udzieleniu dowolnej odpowiedzi o ile only_correct nie jest włączymy i odpowiedź jest zwalidowana, jeśli jest włączony  do odpowiedż musi być prawidłowa
/// Walidacja odpowiedzi następuje gdy odpowiedź jest pusta i dopuszczony jest brak odpowiedzi answer.required = false
/// wpp. odpowiedź musi albo spełniać pattern albo być dokładnie równa repeat_value (używane do tej pory przy EMAIL)

type Hint = {
  //  hint_background_img: string | null; /// jeśli będzie potrzeba to do poprawienia metoda ładowania hintów teraz nie uwzględnia obrazków
  //  over_background_img: string | null;
  //  background_img: string | null;
  text: TextId;
  repetitions: number | null;
  separated_hint?: boolean;
};

const getPerformanceNow = () => Math.round(performance.now()); //czas liczymy z dokładnością do milisekund nie mikrosekund

export class Test {
  private taskStartTime = 0;
  public reactionStartTime = 0;
  public latencyTime = 0;
  public decisionTime = 0;
  private tasks: Task[] = [];
  private iTask = 0;
  protected taskPath: number[] = [];
  protected textSelector: TextSelector;
  protected taskTimers: TimersManager;
  protected testTimers: TimersManager;
  protected activeVideo: HTMLVideoElement | null = null;
  protected bodyClass: string | null = null;
  protected taskPaused = false;
  protected restartOnResume = false;
  public skipNextClickSound = false;
  // eslint-disable-next-line complexity
  protected navigationKeyHandler = (event: KeyboardEvent) => {
    if (event.repeat) {
      return;
    }
    const active = document.activeElement;
    if (
      active instanceof HTMLInputElement ||
      active instanceof HTMLTextAreaElement ||
      (active as HTMLElement)?.isContentEditable
    ) {
      return;
    }
    const key = event.key.toLowerCase();
    const prevKeys = ['e', 'i', 'k'];
    const nextKeys = ['f', 'g', 'm'];
    const startKey = 'o';
    const answerKeyMap: Record<string, string> = { h: 'A', j: 'B' };
    if (
      !prevKeys.includes(key) &&
      !nextKeys.includes(key) &&
      key !== startKey &&
      !answerKeyMap[key]
    ) {
      return;
    }
    if (taskEngine) {
      return;
    }
    const isVisible = (el: HTMLElement | null) =>
      !!el && !el.classList.contains('hidden') && el.offsetParent !== null;
    if (answerKeyMap[key]) {
      const btn = document.getElementById(
        `answer_id_${answerKeyMap[key]}`,
      ) as HTMLElement | null;
      if (btn && isVisible(btn)) {
        event.preventDefault();
        btn.click();
      }
      return;
    }
    const prevBtn = document.getElementById('answer_id_prev');
    const nextBtn = document.getElementById('answer_id_next');
    if (prevKeys.includes(key) && isVisible(prevBtn as HTMLElement | null)) {
      event.preventDefault();
      (prevBtn as HTMLElement).click();
      return;
    }
    if (
      (nextKeys.includes(key) && isVisible(nextBtn as HTMLElement | null)) ||
      (key === startKey && nextBtn)
    ) {
      event.preventDefault();
      (nextBtn as HTMLElement).click();
    }
  };

  constructor(
    protected fnFinishTest: () => void,
    public surveyId: string,
    public testSign: TestSignature,
    protected results: Results,
    protected modeSurvey: ModeSurvey,
  ) {
    this.textSelector = new TextSelector();
    this.taskTimers = new TimersManager();
    this.testTimers = new TimersManager();
    window.addEventListener('keydown', this.navigationKeyHandler);
  }

  protected pendingOriginalValue: string | null = null;

  public setOriginalValue(value: string) {
    this.pendingOriginalValue = value;
  }

  public setReactionStartTime() {
    this.reactionStartTime = getPerformanceNow();
    this.decisionTime = 0;
  }
  public setLatencyTime(latencyTime: number) {
    this.latencyTime = latencyTime;
  }
  public setDecisionTime() {
    if (this.decisionTime === 0) {
      this.decisionTime = getPerformanceNow() - this.reactionStartTime;
    }
  }

  public reloadTest(restart = false) {
    const that = this;
    if (restart) {
      that.iTask = 0;
      that.taskPath = [];
      that.results.removeUnsavedResults(); // czyszczę wyniki z niezapisanych na serwerze
    }
    that.taskTimers.clearAllTimers();
    that.testTimers.clearAllTimers();
    that.translateAllTasks();
    const task = that.getCurrentTask();
    taskEngine && taskEngine.reloadTest && taskEngine.reloadTest(task); ///jeśli jest zdefiniowana metoda w dołączonym enginie sprzątająco po zadaniu
    if (task) {
      that.presentTask(task);
    }
  }

  public reloadTask() {
    const that = this;
    const task = that.getCurrentTask();
    if (task) {
      that.presentTask(task);
    }
  }

  /*
  public activeArea(el: any) {
    const newspaperSpinning = [
      { top: "-=30px" },
      { transform: 'rotate(0) scale(1)' },
      { transform: 'rotate(360deg) scale(0)' }
    ];

    const newspaperTiming = {
      duration: 2000,
      iterations: 1,
    }

    //el.animate(newspaperSpinning, newspaperTiming);
    $(el).animate({
      opacity: 0.25,
      height: "-=50",
      left: "+=250",
    }, 500)
  }
  */

  private concatAnswers(temp_answers: Answer[], task_answers: Answer[]) {
    const newAswers: Answer[] = [];
    if (temp_answers) {
      for (const temp_answer of temp_answers) {
        let answer = temp_answer;
        if (task_answers) {
          for (const task_answer of task_answers) {
            if (temp_answer.code === task_answer.code) {
              answer = { ...temp_answer, ...task_answer };
              continue;
            }
          }
        }
        newAswers[newAswers.length] = answer;
      }
      return newAswers;
    } else {
      return task_answers;
    }
  }

  // eslint-disable-next-line complexity
  protected translateTask(obj: Task) {
    if (obj.title) {
      obj.title = this.textSelector.getText(obj.title);
    }
    if (obj.template_parameters.additional_texts) {
      for (const key in obj.template_parameters.additional_texts) {
        obj.template_parameters.additional_texts[key] =
          this.textSelector.getText(
            obj.template_parameters.additional_texts[key],
          );
      }
    }
    if (obj.task_text) {
      // teksty dla zadania
      obj.task_lange = this.textSelector.getCurrentLange();
      obj.task_text = this.textSelector.getText(obj.task_text);
      obj.task_textPL = this.textSelector.getText(
        obj.task_text,
        Configuration.Lange.PL,
      ).text_presentation;
    }
    if (obj.snd_task && obj.snd_task.text) {
      // teksty dla zadania
      obj.snd_task.src =
        this.textSelector.getText(obj.snd_task.text).sound || '';
    }
    for (const ans of obj.answers) {
      if (ans.text) {
        ans.text = this.textSelector.getText(ans.text);
        ans.textPL = this.textSelector.getText(
          ans.text,
          Configuration.Lange.PL,
        );
      }
    }
    return obj;
  }

  protected translateAllTasks() {
    for (let i = 0; i < this.tasks.length; i++) {
      this.tasks[i] = this.translateTask(this.tasks[i]);
    }
  }

  protected setTasks(default_task: Task, tasks: Task[]) {
    for (const task of tasks) {
      const answers = task.specific_answers
        ? task.answers
        : this.concatAnswers(default_task.answers, task.answers);
      const template_parameters = {
        ...default_task.template_parameters,
        ...task.template_parameters,
      };
      const obj: Task = {
        ...default_task,
        ...task,
        template_parameters: template_parameters,
        answers: answers,
      };
      this.tasks[this.tasks.length] = this.translateTask(obj);
    }
  }

  // eslint-disable-next-line complexity
  protected getNextIndexTaskInMode(currTask: number): number | null {
    for (let idx = currTask; idx < this.tasks.length; idx++) {
      const task = this.tasks[idx];

      if (this.modeSurvey !== ModeSurvey.Examined) {
        const reaction = this.results.getLastComplexReactionForTask(
          task.number,
        );
        switch (task.mode) {
          case ModeTest.StopOnFullMode:
            if (this.modeSurvey === ModeSurvey.PsychologistFull) {
              return idx;
            }
            break;
          case ModeTest.AlwaysStop:
          case ModeTest.HiddenForExamined:
            return idx;
          case ModeTest.StopOnAnswer:
            if (reaction) {
              return idx;
            }
            break;
          case ModeTest.StopOnSpecificAnswer:
            if (reaction) {
              for (const answer of reaction.answers) {
                if (answer.codeAnswer === task.mode_answer) {
                  return idx;
                }
              }
            }
            break;
        }
      } else {
        if (
          (task.mode !== ModeTest.HiddenForExamined || runLocalTest()) &&
          (task.mode !== ModeTest.HiddenOnStandardMode ||
            testConfiguration.public ||
            runLocalTest())
        ) {
          return idx;
        }
      }
    }
    return null;
  }

  protected setCurrentTask(currTask: number) {
    if (currTask >= 0 && currTask < this.tasks.length) {
      this.iTask = currTask;
    }
  }

  protected getCurrentTask() {
    return this.tasks[this.iTask];
  }

  protected getNextTask(): Task | null {
    const idx = this.getNextIndexTaskInMode(++this.iTask);
    if (idx === null) {
      return null;
    }
    this.iTask = idx;
    return this.tasks[this.iTask];
  }

  protected isSelectThisAnswer(
    currTaskNumber: TaskNumber,
    condition: CodeAnswer[],
  ) {
    const lastAnswers =
      this.results.getLastGivenAnswersForTask(currTaskNumber) || [];
    for (const lastAnswer of lastAnswers) {
      for (const conAnswer of condition) {
        if (conAnswer === lastAnswer.codeAnswer) {
          return true;
        }
      }
    }
    return false;
  }

  protected getNextTaskForAnswer(
    currTaskNumber: TaskNumber | null,
    answer: Answer,
  ): Task | null {
    const resolveConditionNextTask = (
      currTaskNumber: TaskNumber,
      condition: ConditionNextTask,
    ): TaskNumber => {
      const isSelect = this.isSelectThisAnswer(
        currTaskNumber,
        condition.condition,
      );
      if (isSelect) {
        return condition.task;
      } else {
        if (typeof condition.other === 'string') {
          return condition.other;
        } else {
          return resolveConditionNextTask(currTaskNumber, condition.other);
        }
      }
    };

    let nextTask = answer?.next_task;
    if (answer?.condition_next_task && currTaskNumber) {
      nextTask = resolveConditionNextTask(
        currTaskNumber,
        answer.condition_next_task,
      );
    }

    if (nextTask) {
      for (let idx = 0; idx < this.tasks.length; idx++) {
        if (this.tasks[idx].number === nextTask) {
          const accessIdx = this.getNextIndexTaskInMode(idx);
          if (accessIdx) {
            // czy zadanie w mode jest dostępne? Jak nie biorę następne w kolejności
            this.iTask = accessIdx;
            return this.tasks[accessIdx];
          } else {
            return null; //doszedł do końca
          }
        }
      }
    }
    return this.getNextTask();
  }

  protected getLastTask() {
    this.iTask = this.tasks.length - 1;
    return this.tasks[this.iTask];
  }

  protected getPrevTask() {
    this.taskPath.pop();
    this.iTask = this.taskPath.pop() || 0;
    //    this.iTask--;

    //  if (this.iTask <= 0) this.iTask = 0;
    return this.tasks[this.iTask];
  }

  private getAnswer(code: CodeAnswer | null) {
    if (code) {
      for (const answer of this.getCurrentTask().answers) {
        if (answer.code === code) {
          return answer;
        }
      }
    }
    return null;
  }

  public pauseTask(pause: boolean) {
    /// metoda wykorzystywana do wstrzymania wykonania testów automatycznymi zadaniami w przypadku braku internetu
    DEBUG_MODE && console.log('pauseTask', pause);
    this.taskPaused = pause;
    const hasTimers = this.testTimers.getCountTimers() > 0;
    if (hasTimers) {
      this.taskTimers.clearAllTimers();
      this.testTimers.clearAllTimers();
      this.restartOnResume = true;
    }
    if (!pause && this.restartOnResume) {
      this.restartOnResume = false;
      this.reloadTest(true);
      return true;
    }
    return false;
  }

  private stopTask() {
    DEBUG_MODE && console.log('stopTask is taskPaused', this.taskPaused);
    if (!this.taskPaused) {
      /// answer - czy zapisywać reakcjach przejście do następnego zadania???
      //speaker.stopSpeaking();
      MySound.stopSounds();
      this.hintNumber = 0;
      taskEngine && taskEngine.stopTask && taskEngine.stopTask(); ///jeśli jest zdefiniowana metoda w dołączonym enginie sprzątająco po zadaniu
      this.taskTimers.clearAllTimers(); ///wykonanie akcji wstrzymuje automatyczne wykonanie zadania? czy tylko gdy odpowiedź jest prawidłowa???
      this.activeVideo && ActivePicture.stopVideo(this.activeVideo);
      /// tu należy pominąć () => that.goToEndTest()
      const task = this.getCurrentTask();

      void this.results.saveResult(task.number); // nie czekam na zapis wyniku !!! poczekam na końcu testu

      taskEngine = null; //wyłączenie enginu
    }
  }

  public stopTest() {
    DEBUG_MODE && console.log('stopTest'); ///!!! trzeba wyczyścić zegary i zapisać koniec testu
    this.testTimers.clearAllTimers();
    this.stopTask();
  }

  private startAnimation(task: Task) {
    for (const answer of task.answers) {
      if (answer.animation) {
        for (const animation of answer.animation) {
          //$('#answer_id_' + answer.code).animate(
          $('*[answer="' + answer.code + '"]').animate(
            animation.param,
            animation.speed,
            'linear',
          );
        }
      }
    }
  }

  protected showActivePicture(task: Task, givenAnswers: GivenAnswer[] | null) {
    for (const answer of task.answers) {
      if (answer.active_picture) {
        let value = '';
        if (givenAnswers) {
          for (const givenAnswer of givenAnswers) {
            if (answer.code === givenAnswer.codeAnswer) {
              value = givenAnswer.value as string;
            }
          }
        }
        this.activeVideo = ActivePicture.create(
          answer.active_picture,
          'answer_id_' + answer.code,
          value,
        );
      }
    }
  }

  public doActionOnActivePicture(
    typeAction: TypeActionOnActivePicture,
    taskNumber: TaskNumber,
    code: string,
    param?: string,
  ) {
    const that = this;
    const task = that.getCurrentTask();
    if (task.number !== taskNumber) {
      DEBUG_MODE &&
        console.log('ZALEGŁA REAKCJA na zadanie', taskNumber, task.number);
      return;
    }

    if (param) {
      const answer = that.getAnswer(param);
      if (answer?.active_picture) {
        ActivePicture.doAction(
          typeAction,
          answer.active_picture,
          'answer_id_' + param,
        );
      }
    }
  }

  public async playSoundOrSpeakText(textId: TextId, must_read = true) {
    const text = this.textSelector.getText(textId);
    if (text?.text_read) {
      await speaker.playSoundOrSpeakText(text.text_read, must_read, text.sound);
    }
  }

  public getTextPresentation(textId: TextId) {
    const text = this.textSelector.getText(textId);
    return text.text_presentation;
  }

  private async startTask(task: Task) {
    const title = task.title as Text;
    const text = task.task_text as Text;

    if (!task.tools.speaker) {
      speaker.switchOff(); /// jeśli nie ma możliwości włączenia speakera to też wyłączamy domyślne czytanie (chodzi o eliminację przypadkowych czytań)
    } else {
      speaker.setVolume(task.speaker_volume); // jeśli jest możliwość włączenia speakera to ustawiamy jego głośność
    }

    if (supervisorMonitor) {
      supervisorMonitor.setTestInformation(this.testSign.name, task.number);
      supervisorMonitor.sendSurveyInformation();
    }

    if (title?.text_read) {
      await speaker.playSoundOrSpeakText(
        title.text_read,
        task.must_read,
        title.sound,
      );
    }
    if (text?.text_read) {
      void speaker.playSoundOrSpeakText(
        text.text_read,
        task.must_read,
        text.sound,
      );
    }

    taskEngine && taskEngine.startTask && taskEngine.startTask(task);

    //// DO ROZWAŻENIA: Obecnie poniższe wykona się dopiero po odtworzeniu całego nagrania - może trzeba zmienić kolejność???
    this.taskStartTime = getPerformanceNow();
    this.reactionStartTime = getPerformanceNow(); /// ten czas domyślnie jest liczony od początku zadania jednak może być wystartowany ponownie np. przez engine
    this.decisionTime = 0;

    this.startAnimation(task);
  }

  protected doneTask() {
    this.nextTaskForAnswer(null, null);
  }

  protected goToEndTest(taskNumber?: TaskNumber | null) {
    this.stopTask(); ///brak odpowiedzi bo czas skończył się

    if (taskNumber) {
      for (let idx = 0; idx < this.tasks.length; idx++) {
        if (this.tasks[idx].number === taskNumber) {
          this.iTask = idx;
          this.presentTask(this.tasks[idx]);
          return;
        }
      }
    }

    this.presentTask(this.getLastTask());
  }

  public async waitForAllSaveResults() {
    await this.results.waitForAllSaveResults();
  }

  public useblockingErrorSeries() {
    this.results.useblockingErrorSeries();
  }

  protected finishTest() {
    this.testTimers.clearAllTimers();
    this.fnFinishTest && this.fnFinishTest();
  }

  protected isReactionTask(task: Task) {
    return this.results.getLastGivenAnswersForTask(task.number) !== null;
  }

  protected selectLastAnswersForTask(task: Task) {
    //const task = this.getCurrentTask();
    const lastAnswers = this.results.getLastGivenAnswersForTask(task.number);
    for (const ans of task.answers) {
      ans.is_selected = false;
      if (lastAnswers) {
        for (const lastAnswer of lastAnswers) {
          if (ans.code === lastAnswer.codeAnswer) {
            ans.is_selected = true;
          }
        }
      }
    }
  }

  protected doneTaskWithAswer() {
    const task = this.getCurrentTask();
    if (this.isReactionTask(task)) {
      this.nextTaskForAnswer(task.number, null);
    }
  }

  public getValue() {
    const task = this.getCurrentTask();
    return this.getValueFromTask(task.number);
  }

  public getValueFromTask(taskNumber: string) {
    const givenAnswer = this.results.getLastGivenAnswerForTask(taskNumber);
    return this.results.getValueFromGiven(givenAnswer, true);
  }

  // eslint-disable-next-line complexity
  protected setValueFromTasksAnswer(task: Task) {
    /// taka prymitywna wstawka kiedyś do poprawienia
    /// pobierająca wartości dla pól prezentujących udzielone odpowiedzi
    for (const answer of task.answers) {
      if (
        answer.task_result_text ||
        answer.task_result_video ||
        answer.task_result_stetho
      ) {
        const givenAnswer = this.results.getLastGivenAnswerForTask(
          answer.task_result_text ||
            answer.task_result_video ||
            answer.task_result_stetho ||
            '',
        );
        const value = this.results.getValueFromGiven(
          givenAnswer,
          false,
        ) as string;
        if (value) {
          if (answer.task_result_text) {
            $('*[answer="' + answer.code + '"] .task_result_text').html(value);
          }
          if (answer.task_result_video) {
            $('*[answer="' + answer.code + '"] video').attr('src', value);
            $('*[answer="' + answer.code + '"]').attr(
              'orgAnswer',
              givenAnswer?.codeAnswer || '',
            );
          }
          if (answer.task_result_stetho) {
            $('*[answer="' + answer.code + '"] iframe').attr('value', value);
          }
        } else {
          $('*[answer="' + answer.code + '"]').hide();
        }
      }
    }
  }

  // eslint-disable-next-line complexity
  protected initializeTaskAnswer(task: Task) {
    // inicjalizacja stanu zadania uzależniona od udzielonych odpowiedzi
    this.setValueFromTasksAnswer(task);

    const givenAnswers = this.results.getLastGivenAnswersForTask(task.number);
    let lastValue;
    let lastAnswer: Answer | null = null;
    if (givenAnswers) {
      for (const givenAnswer of givenAnswers) {
        const answer = this.getAnswer(givenAnswer.codeAnswer);
        this.showConditionallyAnswersForCorrectAnswer(answer);
        /* void this.runConditionallyForSufficientTime(); 
        - włączenie tego tu nie wyłącza timera więc dwa razy jest uruchamiana funkcja 
        - nie wiem dlaczego to tu się pojawiło dlaczego nie można chwilę poczekać na bodziec przy cofaniu 
        DO PRZEMYŚLENIA */

        lastValue = givenAnswer.value;
        lastAnswer = answer;
      }
    }
    this.showActivePicture(task, givenAnswers);

    //////////////////  póki co założenie, że tylko jeden input i/lub jeden activePicture czyli drawing lub scanner
    const value = lastAnswer?.input
      ? lastValue || lastAnswer?.default_value
      : '';

    DEBUG_MODE && console.log('SET INPUT VALUE', value);
    const inputElem = $('.input').first() as JQuery<HTMLInputElement>;
    if (inputElem.length && inputElem.attr('type') === 'file') {
      const inputNode = inputElem.get(0);
      if (inputNode) {
        const rawValue = (value as string) || '';
        const parsed = rawValue ? this.tryParseFileValue(rawValue) : null;
        inputNode.dataset.fileContent = parsed?.src || '';
        inputNode.dataset.fileName = parsed?.name || '';
        const answerCode = inputElem.attr('answer');
        if (answerCode) {
          spd.updateFilePreview(answerCode);
          if (value) {
            $('.show-after-change-input').show();
            $('.hide-after-change-input').hide();
          }
        }
      }
      return;
    }
    if ($('.simple-keyboard').length) {
      if (this.modeSurvey !== ModeSurvey.Examined) {
        ///klawiatura ekranowa będzie pokazywana tylko dla badanego, założenie że psycholog korzysta z normalnej i pracuje na innych rozdzielczościach)
        SPDKeyboard.showEnterKeyboard(value as string);
      } else {
        if (task.keyboard === KeyboardType.pin) {
          SPDKeyboard.showPINKeyboard(value as string);
        } else {
          //SPDKeyboard.showFullKeyboard(this.config.lange, value as string);
          SPDKeyboard.showFullKeyboard(Configuration.Lange.PL, value as string); // zawsze polska klawiatura
        }
      }
    } else {
      $('.input').val(value as string);
    }
  }

  protected setTaskTimers(task: Task) {
    const that = this;
    //włączenie ograniczenia czasowego na zadanie
    that.taskTimers.setTimer(
      'time_max_task_execution',
      task.time_max_task_execution,
      () => that.doneTask(),
    );
    //pokazanie ukrytych opcji
    that.taskTimers.setTimer(
      'time_min_task_presentation',
      task.time_min_task_presentation,
      () => that.runConditionallyForSufficientTime(),
    );

    //włączenie ograniczenia czasowego na zadanie
    that.taskTimers.setTimer(
      'time_min_task_execution',
      task.time_min_task_execution,
      () => that.doneTaskWithAswer(),
    );
    ///nadpisujemy czas wykonania testu
    that.testTimers.reloadTimer(
      'time_max_test_execution',
      task.time_max_test_execution,
      () => that.goToEndTest(task.timeout_task),
    );
  }

  protected async loadMapAnswers(task: Task) {
    let resolveFunction: (value: boolean) => void;
    const loadPromise = new Promise<boolean>((resolve, _) => {
      resolveFunction = resolve;
    });

    $('#map_answers').load(getUrlMedia() + task.map_answers, function () {
      for (const ans of task.answers) {
        const elem = $('*[answer="' + ans.code + '"]');
        if (elem) {
          // ustawianie ma sens tylko gdy jest w mapie taka odpowiedź
          if (ans.is_selected) {
            elem.addClass('selected');
          }
          if (ans.action) {
            elem.on('touch click', async function (e) {
              /// tu chyba powinien być touchend albo tylko click do przetestowania
              e.preventDefault();
              switch (ans.action) {
                case AnswerAction.DoAction:
                  spd.doAction(task.number, ans.code, ans.param);
                  break;
                case AnswerAction.DoNextTask:
                  spd.doNextTask(task.number, ans.code);
                  break;
                case AnswerAction.DoPrevTask:
                  spd.doPrevTask(task.number, ans.code);
                  break;
                case AnswerAction.DoTest:
                  await spd.doTest(task.number, ans.code);
                  break;
                case AnswerAction.DoTestIdent:
                  await spd.doTestIdent(task.number, ans.code);
                  break;
              }
            });
          }
        }
      }
      resolveFunction(true);
    });

    return loadPromise;
  }

  protected loadTemplate(task: Task) {
    const that = this;
    const template = task.template
      ? getUlrTests() + task.template
      : 'template/task-template.mst';

    Loader.loadContentWithVersion(
      '#main',
      template,
      { ...task, mediaUrl: getUrlMedia(), version: getBuildVersion() },
      async function () {
        task.map_answers && (await that.loadMapAnswers(task));
        !DEBUG_MODE && void FullScreen.openFullscreen(); /// !!! test zawsze był fullscreen
        if (task.tools) {
          FooterTools.addTools(task.tools);
        }
        that.initializeTaskAnswer(task);
        await that.startTask(task);
        that.setTaskTimers(task);
      },
    );
  }

  protected presentTask(task: Task) {
    const that = this;
    /// CZY ZAWSZE PREZENTOWANE JEST AKTUALNE ZADANIE? ZAKŁADAM, ZE TAK CZYLI AKTUALNY WSKAŹNIK MÓWI O INDEKSIE ZADANIA
    that.bodyClass && $('body').removeClass(that.bodyClass);
    if (task.body_class) {
      that.bodyClass = task.body_class;
      that.bodyClass && $('body').addClass(that.bodyClass);
    }
    if (that.iTask !== that.taskPath[that.taskPath.length - 1]) {
      //przeładowanie języka spowoduje odłożenie się tego samego zadania na stosie
      that.taskPath.push(that.iTask);
    }

    if (task.time_task_execution) {
      task.time_min_task_execution = task.time_task_execution;
      task.time_max_task_execution = task.time_task_execution;
    }
    that.selectLastAnswersForTask(task);

    if (task.engine) {
      Loader.loadJS('#main', getUlrTests() + task.engine, function () {
        if (task.engine) {
          taskEngine = taskEnginesMap.get(task.engine);
          DEBUG_MODE &&
            console.log(
              'Loaded module:',
              task.engine,
              'Actual engine map:',
              taskEnginesMap,
              'Set taskEngine:',
              taskEngine,
            );
          that.loadTemplate(task);
        }
      });
    } else {
      taskEngine = null; /// czyszczę zmienną na wszelki wypadek by zadanie nie dziedziczyło Enginu po poprzednim
      that.loadTemplate(task);
    }
  }

  protected nextTaskForAnswer(
    currTaskNumber: TaskNumber | null,
    answer: Answer | null,
  ) {
    const that = this;
    if (!this.taskPaused) {
      /// sprawdzamy czy test nie został wstrzymany np. z powodu braku internetu
      that.stopTask(); /// answer - czy zapisywać reakcjach przejście do następnego zadania???

      const task = answer
        ? that.getNextTaskForAnswer(currTaskNumber, answer)
        : that.getNextTask();
      if (task) {
        that.presentTask(task);
      } else {
        that.finishTest();
      }
    }
  }

  public doNextTask(taskNumber: TaskNumber, code: string | null) {
    const that = this;
    const currTask = that.getCurrentTask();
    if (currTask.number !== taskNumber) {
      DEBUG_MODE &&
        console.log('ZALEGŁA REAKCJA na zadanie', taskNumber, currTask.number);
      return;
    }
    that.playClick(currTask);

    const answerNext = that.getAnswer(code);
    that.nextTaskForAnswer(currTask.number, answerNext);
  }

  public playClick(task?: Task) {
    const currTask = task || this.getCurrentTask();
    void MySound.play(currTask.snd_click);
  }

  public playGoodClick(task?: Task) {
    const currTask = task || this.getCurrentTask();
    void MySound.play(currTask.snd_good_click || currTask.snd_click);
  }

  public playBadClick(task?: Task) {
    const currTask = task || this.getCurrentTask();
    void MySound.play(currTask.snd_bad_click || currTask.snd_click);
  }

  public doPrevTask(taskNumber: TaskNumber, code: string) {
    const that = this;
    const task = that.getCurrentTask();

    that.playClick(task);

    if (task.number !== taskNumber) {
      DEBUG_MODE &&
        console.log('ZALEGŁA REAKCJA na zadanie', taskNumber, task.number);
      return;
    }
    //const answer = that.getAnswer(code); /// czy zapisywać reakcjach przejście do następnego zadania????
    that.stopTask();
    that.presentTask(that.getPrevTask());
  }

  protected hintNumber = 0;

  protected getHint(task: Task, hintNumber: number): Hint | null {
    if (task.hints && task.hints.length > 0) {
      let max = 0;
      for (const hint of task.hints) {
        max += hint.repetitions || 1;
        if (hintNumber < max) {
          return hint;
        }
      }
      return task.hints[task.hints.length - 1];
    }
    return null;
  }

  protected clearHint(task: Task) {
    const that = this;
    if (that.hintNumber > 0) {
      const hint = that.getHint(task, that.hintNumber);
      if (hint && hint.separated_hint) {
        $('.hint_text').html('');
      } else {
        $('.task_text').html('');
      }
    }
  }

  public clearTaskHint() {
    const that = this;
    const task = that.getCurrentTask();
    that.clearHint(task);
  }

  public showTaskHint(nr: number) {
    const that = this;
    const task = that.getCurrentTask();
    that.hintNumber = nr;
    that.showHint(task);
  }

  protected showHint(task: Task) {
    const that = this;
    const hint = that.getHint(task, that.hintNumber);
    if (hint && hint.text) {
      that.hintNumber++;
      const text = that.textSelector.getText(hint.text);

      const taskWithHint: Task = {
        ...task,
        task_text: text,
        //  background_img: hint.background_img || task.background_img,
        //  over_background_img: hint.over_background_img || task.over_background_img,
        //  hint_background_img: hint.hint_background_img
      };
      ///loader.loadContent('#main', 'template/task-template.mst', taskWithHint, function (task: Task) {/// pytanie czy przeładowywać całe zadanie czy tylko elementy??
      ///  const text = taskWithHint.task_text as Text;
      ///if (task.tools) FooterTools.addTools(that.config.lange, task.tools);

      if (hint.separated_hint) {
        $('.hint_text').html(text.text_presentation); //// pamiętać ewentualnie o obrazku
      } else {
        $('.task_text').html(text.text_presentation); //// pamiętać ewentualnie o obrazku
      }
      if (text.text_read) {
        void speaker.playSoundOrSpeakText(
          text.text_read,
          task.must_read,
          text.sound,
        );
      }
      //});
    }
  }

  protected isSufficientPresentationTime(): boolean {
    const task = this.getCurrentTask();
    const endTime = getPerformanceNow();
    if (task.time_min_task_presentation) {
      DEBUG_MODE &&
        console.log(
          'isSufficientPresentationTime',
          endTime,
          this.taskStartTime,
          task.time_min_task_presentation,
        );
      return endTime - this.taskStartTime > task.time_min_task_presentation;
    }
    return true;
  }
  protected isTaskCanBeDone(task: Task): boolean {
    const endTime = getPerformanceNow();
    if (task.time_min_task_execution) {
      return endTime - this.taskStartTime > task.time_min_task_execution;
    }
    return true;
  }

  protected async runConditionallyForSufficientTime() {
    DEBUG_MODE && console.log('runConditionallyForSufficientTime');

    if (this.isSufficientPresentationTime()) {
      this.showConditionallyForSufficientTime();
      const task = this.getCurrentTask();
      await this.playTaskSound(task.snd_task);
    }
  }

  protected async playTaskSound(sound: SoundParam) {
    DEBUG_MODE && console.log('playTaskSound', sound);
    if (sound) {
      await MySound.playSound(sound);
    }
  }

  public showConditionallyForInputChange() {
    $('.show-after-change-input').show();
    $('.hide-after-change-input').hide();
  }

  protected showConditionallyForSufficientTime() {
    ///if (this.isSufficientPresentationTime()) {
    /// zawsze true bo wcześniej sprawdzone???? - jakaś zaszłość
    $('.after-min-time').show();
    ///} else {
    ///  $('.after-min-time').hide();
    ///}
  }

  protected showConditionallyAnswersForCorrectAnswer(answer: Answer | null) {
    if (answer) {
      if (answer.correct) {
        $('.correct-last-answer').show();
      } else {
        $('.correct-last-answer').hide();
      }
      $('.any-answer').show();
      $('.show-after-change-input').hide();
    } else {
      $('.any-answer').hide();
    }
  }

  protected collectAnswer(
    answer: Answer,
    number: TaskNumber,
    taskTextPL: string,
    taskLange: Configuration.Lange,
  ) {
    this.showConditionallyAnswersForCorrectAnswer(answer);
    const valuePL = this.getAnswerValue(answer, true);
    const valueOriginal = this.getAnswerValue(answer, false);
    const pendingOriginal = this.pendingOriginalValue;
    this.pendingOriginalValue = null;
    //wartością będzie podana wartość input lub acticePicture, lub zdefioniowany tekst albo kod odpowiedzi
    this.results.collectAnswer(
      answer.complex || false,
      number,
      taskTextPL,
      taskLange,
      pendingOriginal || (valuePL !== valueOriginal ? valueOriginal : null),
      answer.code,
      getPerformanceNow() - this.taskStartTime,
      this.latencyTime,
      this.decisionTime,
      getPerformanceNow() - this.reactionStartTime,
      valuePL,
      answer.core_field_name,
      answer.critical_type,
      answer.value_type,
      this.modeSurvey,
    );
  }

  // eslint-disable-next-line complexity
  protected getAnswerValue(answer: Answer, withTranslation = true) {
    //wartością będzie podana wartość input lub acticePicture, lub zdefioniowany tekst albo kod odpowiedzi
    //const id = 'answer_id_' + answer.code;
    //const elem = $('[answer="' + answer.code + '"]');
    const elem = document.querySelector(
      '[answer="' + answer.code + '"]',
    ) as HTMLElement;

    if (elem) {
      if (answer.input) {
        if ((elem as HTMLInputElement).type === 'file') {
          const input = elem as HTMLInputElement;
          const src = input.dataset.fileContent || '';
          const name = input.dataset.fileName || '';
          return src ? JSON.stringify({ name, src }) : '';
        }
        return ($(elem).val() as string).trim();
      }
      if (answer.calculated) {
        return $(elem).attr('value');
      }
      if (answer.active_picture) {
        return ActivePicture.getDataUrl(
          answer.active_picture,
          elem,
          answer.param_check_complex,
        );
      }
    }
    if (answer.standard_value) {
      // For coded answers keep code in saved value, but allow label in valueOriginal/summary.
      if (withTranslation) {
        return answer.standard_value;
      }
      if (answer?.text) {
        return (answer?.text as Text).text_presentation;
      }
      return answer.standard_value;
    }
    /// podajemy zawsze polskie tłumaczenie odpowiedzi oryginalna odpowiedź jest w answer.text
    if (answer?.textPL && withTranslation) {
      return (answer?.textPL as Text).text_presentation;
    } else {
      if (answer?.text) {
        return (answer?.text as Text).text_presentation;
      }
    }

    return answer.code;
  }

  protected tryParseFileValue(
    value: string,
  ): { name: string; src: string } | null {
    try {
      const parsed = JSON.parse(value) as { name?: string; src?: string };
      if (parsed && typeof parsed.src === 'string') {
        return { name: parsed.name || '', src: parsed.src };
      }
      return null;
    } catch {
      return null;
    }
  }

  protected isValidatedAnswer(answer: Answer) {
    if (
      answer &&
      (answer.input || answer.calculated || answer.active_picture)
    ) {
      //dla pól typu input lub activePicture sprawdzamy czy została wypełniona wartość
      const value = this.getAnswerValue(answer);
      /// można spróbować tak, że potem wyliczany hint na podstawie wartości czyli dopisać procedurę, która liczy hinta dla odpowiedzi
      ///lub go iteruje, dodać parametr do testu jakie warunki musi spełniać obrazek a potem w zależności o d sytuacji zwracać czego nie spełnia
      const isEmpty = !value;
      DEBUG_MODE &&
        console.log('isValidatedAnswer', value?.substring(0, 100), isEmpty);

      if (answer.pattern && !isEmpty) {
        const pattern = new RegExp(answer.pattern);
        return pattern.test(value);
      }

      if (answer.repeat_value) {
        const val = this.results.getLastGivenValueForTask(answer.repeat_value);
        return val === value;
      }

      return answer.required ? !isEmpty : true;
    } else {
      return true;
    }
  }

  protected showProperHint(task: Task, answer: Answer | null) {
    const that = this;
    if (!task.only_engine_hint) {
      if (answer && answer.active_picture) {
        // obecnie tylko dla podpisów wyliczamy hint
        const elem = document.querySelector(
          '[answer="' + answer.code + '"]',
        ) as HTMLElement;
        that.hintNumber = ActivePicture.getProblemCode(
          answer.active_picture,
          elem,
          answer.param_check_complex,
        );
      }
      that.showHint(task);
    }
  }

  // eslint-disable-next-line complexity
  public doAction(
    taskNumber: TaskNumber,
    code: string,
    param?: string,
  ): boolean {
    const that = this;
    const task = that.getCurrentTask();
    if (task.number !== taskNumber) {
      DEBUG_MODE &&
        console.log('ZALEGŁA REAKCJA na zadanie', taskNumber, task.number);
      return false;
    }
    if (that.isSufficientPresentationTime()) {
      const click = new Audio(getUrlMedia() + task.snd_click);
      const badClick = new Audio(getUrlMedia() + task.snd_bad_click) || click;
      //const goodClick = new Audio(getUrlMedia() + task.snd_good_click) || click;

      const processedAnswerCode = param || code; /// jeśli podany jest parametr tzn. że chcemy procesować odpowiedź z innego obiektu używane obecnie tylko do Drawing i Scan
      const answer = that.getAnswer(processedAnswerCode);
      const orgAnswer = that.getAnswer(code); /// warunki przejścia będą pobrane z oryginalnej odpowiedzi

      const isValidatedAnswer = answer && that.isValidatedAnswer(answer);
      DEBUG_MODE && console.log('WALIDACJA ODPOWIEDZI', isValidatedAnswer);
      /// odpowiedź zaznaczamy lub odznaczamy przy multiwyborze gdy ta sama
      if (isValidatedAnswer) {
        this.clearHint(task);
        answer &&
          that.collectAnswer(
            answer,
            task.number,
            task.task_textPL,
            task.task_lange,
          );
        if (answer && answer.complex) {
          void MySound.play(task.snd_good_click || task.snd_click);
          if (!answer.input) {
            answer.is_selected = !(answer.is_selected || false);
            answer.is_selected
              ? $('*[answer="' + processedAnswerCode + '"]').addClass(
                  'selected',
                )
              : $('*[answer="' + processedAnswerCode + '"]').removeClass(
                  'selected',
                );

            if ($('.selected').length === 0) {
              // jeśli nie ma żadnych odpowiedzi zaznaczonych to ukrywamy warunkowe
              this.showConditionallyAnswersForCorrectAnswer(null);
            }
          }
          return true; /// jeśli doAction ma dawać informację o pozytywnym przejściu walidacji to true, jeśli zaś informację czy przeszło do następnego zadania to false
        }

        if (answer) {
          answer.is_selected = true; //przy pojedynczym zawsze zaznaczamy - do rozważanie odznaczanie??
          //$('.answer-button').removeClass('selected');
          //$('#answer_id_' + code).addClass('selected');
          $('*[answer]').removeClass('selected');
          $('*[answer="' + processedAnswerCode + '"]').addClass('selected');
        }
      } else {
        this.showConditionallyAnswersForCorrectAnswer(null); // ukrawam warunkowe odpowiedzi jeśli ostatnia odpowiedź nie jest zwalidowana
      }
      if (
        answer &&
        (answer.correct ||
          (task.next_after_answer && !task.only_correct && isValidatedAnswer))
      ) {
        if (this.skipNextClickSound) {
          this.skipNextClickSound = false;
        } else {
          void MySound.play(task.snd_good_click || task.snd_click);
        }

        if (that.isTaskCanBeDone(task)) {
          if (task.time_next_delay) {
            that.taskTimers.setTimer(
              'time_next_delay',
              task.time_next_delay,
              () => that.nextTaskForAnswer(task.number, orgAnswer),
            );
          } else {
            that.nextTaskForAnswer(task.number, orgAnswer);
          }
        }
        return true;
      } else {
        if (answer && answer.input && isValidatedAnswer) {
          // gdy prawidłowa odpowiedź nie powoduje przejścia do następnego zadania
          void MySound.play(task.snd_good_click || task.snd_click);
          return true; /// jeśli doAction ma dawać informację o pozytywnym przejściu walidacji to true, jeśli zaś informację czy przeszło do następnego zadania to false
        } else {
          badClick.currentTime = 0;
          void MySound.play(task.snd_bad_click || task.snd_click);
          that.showProperHint(task, answer);
          return false;
        }
      }
    }
    return false;
  }

  protected async runTest(data: DataTest, startTask?: number) {
    const that = this;
    data.db_texts && (await this.textSelector.setDbTexts(data.db_texts));
    that.setTasks(data.default_task, data.tasks);
    const idxTask = that.getNextIndexTaskInMode(startTask || 0);
    if (idxTask === null) {
      //nie ma żadnego zadania do wykonania/pokazania
      that.finishTest();
    } else {
      idxTask && that.setCurrentTask(idxTask);
      that.presentTask(that.getCurrentTask());
    }
  }

  public static clearTestThemeCSS() {
    const cssCount = $('link[id^="local_test_css"]').length;

    $('link[id^="local_test_css"]').each(function () {
      $(this).remove(); // Usuń każdy znaleziony element
    });

    DEBUG_MODE && console.log('clearTestThemeCSS', cssCount);
  }

  public static async loadTest(
    modeSurvey: ModeSurvey,
    fnFinishTest: () => void,
    surveyId: string,
    testSign: TestSignature,
    startTask?: number,
  ): Promise<Test | null> {
    const url = getUlrTests() + testSign.url;
    try {
      const data: DataTest = await Loader.getSyncJSONWithVersion(url);
      const results = await Results.loadResults(surveyId, testSign.id);
      Test.clearTestThemeCSS();
      if (data.theme) {
        if (typeof data.theme === 'string') {
          Loader.loadCSS(getUrlCSS() + data.theme, 'local_test_css');
        } else {
          for (const [id, theme] of data.theme.entries()) {
            Loader.loadCSS(getUrlCSS() + theme, 'local_test_css' + id);
          }
        }
      }
      const test = new Test(
        fnFinishTest,
        surveyId,
        testSign,
        results,
        modeSurvey,
      );
      await test.runTest(data, startTask);
      return test;
      // eslint-disable-next-line @typescript-eslint/no-explicit-any
    } catch (e: any) {
      DEBUG_MODE &&
        alert(
          'Wystąpił błąd podczas inicjacji testu [loadTest]:' + testSign.name,
        );
      console.error('loadTest: CATCH: ', e);
      Sentry.captureException(e);
    }
    return null;
  }

  public getTemplateParameters() {
    const task = this.getCurrentTask();
    return task.template_parameters;
  }

  public getTestFileName() {
    return this.testSign.url;
  }

  public buildIndicatorResultsPayload() {
    const timestamp = new Date().toISOString();
    return {
      results: this.results.getResults().map(result => ({
        timestamp,
        result,
      })),
    };
  }
}
